import { toast, ExternalToast } from 'sonner';

export function useNotification() {
  return {
    success: (message: string, options: ExternalToast = {}) =>
      toast.success(message, { ...options, closeButton: true }),
    info: (message: string, options: ExternalToast = {}) =>
      toast.info(message, { ...options, closeButton: true }),
    error: (message: string, options: ExternalToast = {}) =>
      toast.error(message, { ...options, closeButton: true }),
  };
}
